import { SttClientAdapter, SttClientResult } from './stt-adapter.interface';

export class WebSpeechSttAdapter implements SttClientAdapter {
  private recognition: any = null;
  private startTime = 0;

  isLocal(): boolean {
    return true;
  }

  isSupported(): boolean {
    return 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
  }

  startListening(): void {
    const SR = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    this.recognition = new SR();
    this.recognition.lang = 'ru-RU';
    this.recognition.interimResults = false;
    this.recognition.maxAlternatives = 1;
    this.startTime = Date.now();
    this.recognition.start();
  }

  stopListening(): Promise<SttClientResult> {
    return new Promise((resolve, reject) => {
      if (!this.recognition) {
        reject(new Error('Recognition not started'));
        return;
      }

      this.recognition.onresult = (event: any) => {
        const text = event.results[0][0].transcript;
        resolve({
          text,
          processingTimeMs: Date.now() - this.startTime,
          isLocal: true,
        });
      };

      this.recognition.onerror = (event: any) => {
        reject(new Error(`Web Speech error: ${event.error}`));
      };

      this.recognition.onend = () => {
        // If no result was returned before onend
      };

      this.recognition.stop();
    });
  }
}
